module.exports = __webpack_public_path__ + "img/ganondorf-min.fa818d8d.png";